import { createContext, useContext, useEffect, useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=anon, object=auth
  const [error, setError] = useState("");

  useEffect(() => {
    let alive = true;
    api
      .get("/auth/me")
      .then((r) => alive && setUser(r.data))
      .catch(() => alive && setUser(false));
    return () => {
      alive = false;
    };
  }, []);

  const login = async (email, password) => {
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setUser(data);
      return true;
    } catch (e) {
      setError(formatApiErrorDetail(e.response?.data?.detail) || e.message);
      return false;
    }
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (err) {
      // Logout is best-effort; even if the server call fails we still clear local state.
      console.warn("Logout request failed:", err);
    }
    setUser(false);
  };

  return (
    <AuthCtx.Provider value={{ user, error, login, logout, setUser }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
